import { SvgIcon, SvgIconProps } from "@mui/material";

export default function CalendarRangeIcon(props: SvgIconProps) {
    return (
        <SvgIcon width="60" height="60" viewBox="0 0 60 60" fill="none" {...props}>
            <g>
                <g>
                    <path d="M22.5 25H17.5V30H22.5V25ZM32.5 25H27.5V30H32.5V25ZM42.5 25H37.5V30H42.5V25ZM47.5 7.5H45V2.5H40V7.5H20V2.5H15V7.5H12.5C9.725 7.5 7.5 9.75 7.5 12.5V47.5C7.5 48.8261 8.02678 50.0979 8.96447 51.0355C9.90215 51.9732 11.1739 52.5 12.5 52.5H47.5C48.8261 52.5 50.0979 51.9732 51.0355 51.0355C51.9732 50.0979 52.5 48.8261 52.5 47.5V12.5C52.5 11.1739 51.9732 9.90215 51.0355 8.96447C50.0979 8.02678 48.8261 7.5 47.5 7.5ZM47.5 47.5H12.5V20H47.5V47.5Z"  />
                </g>
            </g>
        </SvgIcon>)
}
